module.exports = __webpack_public_path__ + "img/trainCamp.5b09c4c0.png";